import { memo } from 'react';

import { Tr } from '@frontend/components';

import { ColumnConfig, RowDataConstraint } from '../types';
import { MemoizedDataRowCell } from './DataRowCell';

export type DataRowProps<
  ColumnId extends string,
  RowData extends RowDataConstraint,
> = {
  columns: ColumnConfig<ColumnId, RowData>[];
  rowData: RowData;
  stickyLeftColumnId: ColumnId;
  rowLinkDestination: string;
  rowIsHighlighted?: boolean;
};

export const DataRow = <
  ColumnId extends string,
  RowData extends RowDataConstraint,
>({
  columns,
  rowData,
  stickyLeftColumnId,
  rowLinkDestination,
  rowIsHighlighted = false,
}: DataRowProps<ColumnId, RowData>) => {
  return (
    <Tr
      isInteractive
      _first={{
        td: {
          borderTopWidth: 0,
        },
      }}
    >
      {columns.map((column) => {
        const { columnId } = column;
        const isStickyLeftColumn = columnId === stickyLeftColumnId;
        return (
          <MemoizedDataRowCell
            key={columnId}
            column={column}
            rowData={rowData}
            isHighlighted={rowIsHighlighted}
            isStickyLeftColumn={isStickyLeftColumn}
            rowLinkDestination={rowLinkDestination}
          />
        );
      })}
    </Tr>
  );
};

export const MemoizedDataRow = memo(DataRow);
